import { Route } from 'react-router-dom';
import { IRouteDefinition } from './types';
import { RouteWithLayout } from '../layouts/RouteWithLayout';

export const generateRoutesFromDefinitionList = (
  definitionList: Record<string, IRouteDefinition>
) => {
  return Object.keys(definitionList).map((routeName) => {
    const routeDefinition = definitionList[routeName];

    return (
      <Route
        key={routeDefinition.name}
        path={routeDefinition.path}
        element={
          <RouteWithLayout layout={routeDefinition.layout}>
            {routeDefinition.element}
          </RouteWithLayout>
        }
      />
    );
  });
};
